import React, { memo } from 'react';

import { Guideline } from '@components/common';

import { Icons } from '@icons/icons';

import { IIdType } from '@interfaces/common/common';
import { IPortalLinkedTask } from '@interfaces/portal/tasks';

import colors from '@constants/colors';
import { linkedTasksStatusNames } from '@constants/common';
import { inactiveLinkedTaskText, unlinkIconSize } from './constants';

import styles from './LinkedTaskItem.module.scss';

interface ILinkedTaskItemProps {
	linkedTask: IPortalLinkedTask;
	setTaskForUnlink: (data: IIdType) => void;
	showUnlinkConfirm: () => void;
	getTaskDatesInfo: (startDate?: string, endDate?: string) => string | undefined;
	isViewMode: boolean;
}

const LinkedTaskItem = ({
	linkedTask,
	setTaskForUnlink,
	showUnlinkConfirm,
	getTaskDatesInfo,
	isViewMode,
}: ILinkedTaskItemProps) => {
	const {
		id,
		taskId,
		title,
		status,
		startDate,
		endDate,
		type,
	} = linkedTask;

	const backgroundColor = status.name === linkedTasksStatusNames.active && !isViewMode
		? colors.indigo05
		: colors.gray05;

	const datesInfo = getTaskDatesInfo(startDate, endDate);

	const unlinkTask = () => {
		setTaskForUnlink({
			id,
			type: type.name,
		});

		showUnlinkConfirm();
	};

	return (
		<div
			className={styles.linkedTaskContainer}
			style={{
				backgroundColor,
			}}
		>
			<div className={styles.taskTitle}>
				{`${taskId} ${title}`}
			</div>
			<div className={styles.taskActions}>
				{datesInfo && <div className={styles.datesInfo}>{datesInfo}</div>}
				{status.name === linkedTasksStatusNames.inactive
					&& <div className={styles.guidelineIcon}>
						<Guideline
							guidelineText={inactiveLinkedTaskText}
							placement='top'
						/>
					</div>
				}
				{!isViewMode
					&& <div
						className={styles.unlinkIcon}
						onClick={unlinkTask}
					>
						{Icons.unlink({ width: unlinkIconSize, height: unlinkIconSize })}
					</div>
				}
			</div>
		</div>
	);
};

export default memo(LinkedTaskItem);
